import Vue from 'vue';
import Vuex from 'vuex';
import { gzip } from 'node-gzip';
import router from '@/router';

import moment from 'moment';

// window.router_history = [

// ];

//router.afterEach(to => {

//   console.log('to.path', to.path);
//   if(to.path.includes('cart')){
//     store.commit('toggleCartLinkActive',true);
//   }
// });

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
	// for Google Analytics
	if (typeof window.send_ga == 'function') {
		setTimeout(window.send_ga, 1000);
	}
	//console.log('router.afterEach');
});

// https://www.npmjs.com/package/vue-localstorage
import VueLocalStorage from 'vue-localstorage';
import { get } from 'core-js/core/dict';
Vue.use(VueLocalStorage);

window.$ = require('jquery');
window.JQuery = require('jquery');

Vue.use(Vuex);

export default new Vuex.Store({
	// initial state
	state: {
		overlappedActivities: null,

		getTimesLoading: false,

		getOrderLoading: true,

		cartLinkActive: false,

		historyDistanceToHomePage: 0,

		globalModal: {
			show: true,
			body: '<p>Global Modal</p>',
		},

		removeFromCartModal: {
			show: false,
			hideHeader: true,
			id: 'removeFromCartModal',
			loading: false,
		},

		productToRemove: {},

		discount: {
			value: '',
			message: '',
			error: '',
			ajaxing: false,
		},

		activeProductIds: {
			id: null,
			productType: null,
		},
		updateOrderManagement: {
			timer: null,
			ajax: null,
		},
		order: {},
		client: {},
		clientOriginal: {},
		agentKey: null,

		// environment:
		//  document.domain == "localhost" ? "environment_dev" : "environment_live",
		//clientLocationKey: 1, // this is now being passed in the URI
		//imagePath:
		//  document.domain == "localhost"
		//   ? "http://localhost:8080/static/img"
		//    : "/assets/static/img",

		environment: document.domain === 'localhost' ? 'development' : false,

		serverPath: window.serverPath,

		currentAjaxCall: null,
	},

	// like computed state properties
	getters: {
		clientAgentKey: function(state) {
			return state.agentKey;
		},
		// used for Sojern when completing a conversion
		simpleProducts: function(state) {
			if (state.order && state.order.OrderKey) {
				let combinedProducts = [
					...state.order.Individual,
					...state.order.Packages,
					//...state.order.GiftCards
				];

				let products = [];

				combinedProducts.forEach((row) => {
					let departureDate = false;
					let returnDate = false;
					let totalParticipants = 0;
					if (row.Activities) {
						row.Activities.forEach((act) => {
							totalParticipants += act.TotalParticipants;

							let dd = moment(act.AppointmentDate).format('YYYY/MM/DD');

							departureDate =
								!departureDate || dd < departureDate ? dd : departureDate;
							returnDate = !returnDate || dd > returnDate ? dd : returnDate;
						});
					}

					products.push({
						departureDate: departureDate,
						returnDate: returnDate,
						id: row.EntityHierarchyKey,
						orderNumber: state.order.OrderNumber,
						name: row.Name,
						currency: state.client.SquareCurrencyCode,
						price: row.SubTotal.toFixed(2),
						quantity: totalParticipants,
						isPackage: row.PackageKey ? true : false,
					});
				});

				return {
					city: state.client.City,
					state: state.client.State,
					postalCode: state.client.PostalCode,
					country: state.client.CountryCode,
					orderNumber: state.order.OrderNumber,
					locationName: state.client.Name,
					subTotal: state.order.SubTotal.toFixed(2),
					tax: state.order.TaxTotal.toFixed(2),
					total: state.order.Total.toFixed(2),
					products: products,
				};
			} // if
			else {
				return null;
			}
		},

		simpleOrder: function(state) {
			let act = [];

			if (state.order && state.order.OrderKey) {
				let combinedProducts = [
					...state.order.Individual,
					...state.order.Packages,
					...state.order.GiftCards,
				];

				combinedProducts.forEach((row) => {
					if (row.Activities) {
						row.Activities.forEach((a) => {
							act.push({
								appointmentDate: a.AppointmentDate,
								id: a.EntityHierarchyKey,
								orderNumber: state.order.OrderNumber,
								name: a.Name,
								currency: state.SquareCurrencyCode,
								price: a.SubTotal.toFixed(2),
								quantity: a.TotalParticipants ? a.TotalParticipants : 0,
							});
						});
					}
				});

				return {
					city: state.City,
					state: state.State,
					postalCode: state.PostalCode,
					country: state.CountryCode,
					orderNumber: state.order.OrderNumber,
					locationName: state.Name,
					subTotal: state.order.SubTotal.toFixed(2),
					tax: state.order.TaxTotal.toFixed(2),
					total: state.order.Total.toFixed(2),
					activities: act,
				};
			} else {
				return null;
			}
		}, // simpleOrder

		productsInCart: (state) => {
			if (state.order.OrderKey) {
				//return 444;
				//alert(state.order.Individual.length);
				return state.order.Individual.length + state.order.Packages.length;
			}
			return 0;
		},

		packages: (state) => {
			return state.client.Packages;
		},
		individual: (state) => {
			return state.client ? state.client.Individual : [];
		},

		logoDark: (state) => {
			if (state.client.DarkLogoVersion) {
				return (
					state.client.PhotoDomain +
					'h_140' +
					'/v' +
					state.client.DarkLogoVersion +
					state.client.PhotoFolder +
					'/darklogo'
				);
			}

			return false;
		},

		logoLight: (state) => {
			if (state.client.DarkLogoVersion) {
				return (
					state.client.PhotoDomain +
					'h_140' +
					'/v' +
					state.client.DarkLogoVersion +
					state.client.PhotoFolder +
					'/lightlogo'
				);
			}

			return false;
		},

		productSubTotal: (state, getters) => {
			let t = 0; // total
			let peeps = 0; // Participants

			if (
				getters.activeProductDetails &&
				getters.activeProductDetails.Activities
			) {
				getters.activeProductDetails.Activities.forEach((act) => {
					if (act.SelectedTimes) {
						//alert("subtotal: subtotal like large group mode");
						act.SelectedTimes.forEach((st) => {
							// private tour
							// console.log("SelectedTimes", st.SubTotal);
							// add the price (or slashThroughPrice) of the rate marked as IsPrivateTourRate
							// if (act.IsPrivateTour) {
							//   let findPrivateRate = st.Rates.find(rate => {
							//     return rate.IsPrivateTourRate;
							//   });

							//   if (findPrivateRate) {
							//     t += findPrivateRate.Price;
							//   }
							// }
							// //
							// else
							if (!getters.activeProductDetails.IsLargeGroup) {
								// for not private tour
								//console.log("not large group tour");

								t += st.SubTotal;
								// st.Rates.forEach(rate => {
								//   if (!rate.IsPrivateTourRate) {
								//     peeps = peeps + rate.Participants;
								//     t = t + rate.Participants * rate.Price;
								//   }
								// });
							}
							//
							else if (getters.activeProductDetails.IsLargeGroup) {
								// for not private tour
								//console.log("IS large group tour");

								//t += st.SubTotal;
								st.Rates.forEach((rate) => {
									if (!rate.IsPrivateTourRate) {
										peeps = peeps + rate.Participants;
										t = t + rate.Participants * rate.Price;
									}
								});
							}

							if (st.AddOns) {
								st.AddOns.forEach((ad) => {
									t =
										t +
										ad.Quantity *
											(ad.AddOnDiscount
												? ad.PublishedPrice - ad.AddOnDiscount
												: ad.PublishedPrice);
								});
							}

							// if (st.PickupLocation) {
							//   t += peeps * st.PickupLocation.PickupCost;
							// }
						});
					}
				});
			}

			return t;
		},

		//
		activeProductDetails: (state) => {
			let productDetails = {
				Activities: [
					{
						Rates: [],
					},
				],
			};
			// modifying
			if (state.activeProductIds.modify && state.order) {
				//alert("activeProductDetails if");
				if (
					state.activeProductIds.productType === 'activity' &&
					state.order.Individual
				) {
					//alert('modify individual ' + state.activeProductIds.id);
					productDetails = state.order.Individual.find((ele) => {
						return ele.OrderEntityKey == state.activeProductIds.id;
					});
				} else if (
					state.activeProductIds.productType === 'package' &&
					state.order.Packages
				) {
					//alert('modify package');
					productDetails = state.order.Packages.find((ele) => {
						return ele.OrderPackageKey == state.activeProductIds.id;
					});
				}
			}
			// not modifying
			else {
				//alert("activeProductDetails else");
				if (
					state.activeProductIds.productType === 'activity' &&
					state.client.Individual
				) {
					// alert(
					//   "new individual state.activeProductIds.id: " +
					//     state.activeProductIds.id +
					//     " state.client.Individual.length: " +
					//     state.client.Individual.length
					// );
					// if (state.activeProductIds.pkgKey) {
					// 	productDetails = state.client.Individual.find((e) => {
					// 		return (
					// 			e.EntityHierarchyKey * 1 == state.activeProductIds.id * 1 &&
					// 			e.PackageKey == state.activeProductIds.pkgKey
					// 		);
					// 	});
					// } else
					productDetails = state.client.Individual.find((ele) => {
						// return (
						// 	ele.EntityHierarchyKey * 1 == state.activeProductIds.id * 1
						// );
						return (
							ele.EntityHierarchyKey * 1 == state.activeProductIds.id * 1 &&
							ele.PackageKey == state.activeProductIds.pkgKey
						);
					});
				} else if (
					state.activeProductIds.productType === 'package' &&
					state.client.Packages
				) {
					//alert('new package');
					productDetails = state.client.Packages.find((ele) => {
						return ele.PackageKey == state.activeProductIds.id;
					});
				}
			}

			//productDetails.ClientLocationKey = router.currentRoute.params.client;

			// make a deep copy of details so that doesn't persist
			// var details_clone = JSON.parse(JSON.stringify(details));
			console.log('productDetails :>>', productDetails);
			if (!productDetails.ShowFirstActivityOnly) state.hiddenActivities = null;
			return productDetails;
			//return details_clone;
		}, // activeProductDetails getter
	},

	// make changes to the state
	mutations: {
		// setHistoryDistanceToHomePage(state, payload) {

		// },
		clearCartCount(state) {
			state.order.CartCount = 0;
		},
		// remove any discount
		clearDiscount(state) {
			state.discount = {
				value: '',
				message: '',
				error: '',
				ajaxing: false,
			};
		},
		revertClient(state) {
			// simple restores the client object back to it's original version
			//setTimeout(() => {
			state.client = JSON.parse(JSON.stringify(state.clientOriginal));
			//}, 1500);
		},

		toggleCartLinkActive(state, payload) {
			state.cartLinkActive = payload;
		},

		togglePrivateTour(state, payload) {
			var findDetails;
			if (state.activeProductIds.modify && state.order) {
				findDetails = state.order.Individual.find((ele) => {
					return (
						ele.EntityHierarchyKey == payload.entityHierarchyKey &&
						ele.OrderEntityKey == state.activeProductIds.id
					);
				});
			} else {
				findDetails = state.client.Individual.find((ele) => {
					return ele.EntityHierarchyKey == payload.entityHierarchyKey;
				});
			}

			if (findDetails) {
				// you cannot have a large group if it's a private tour
				if (payload.newVal == true && findDetails.IsLargeGroup) {
					findDetails.IsLargeGroup = false;
				}

				//
				var findPrivateRate = findDetails.Activities[0].Rates.find((ele) => {
					return ele.IsPrivateTourRate === true;
				});

				if (findPrivateRate) {
					//alert('findPrivateRate.Name: ' + findPrivateRate.Name);
					if (payload.newVal === true) {
						// make it private
						findPrivateRate.Participants = 1;
					} else {
						findPrivateRate.Participants = 0;
					}
				} else {
					console.warn('Unable to find private rate!');
				}
			}
		},

		/*
    skipAddOnsForTime(state, payload) {

      //alert('TODO: skipping should revert the state. (not save)');

      let findDetails = false;

      if (payload.packageKey) {
        findDetails = state.client.Packages.find((ele) => {
          return ele.PackageKey == payload.packageKey;
        });


        // try order object
        if(!findDetails){
          findDetails = state.order.Packages.find((ele) => {
            return ele.OrderPackageKey === payload.orderPackageKey;
          });
        }

        alert('packageKey '+findDetails.length);
      }

      else {
        findDetails = state.client.Individual.find((ele) => {
          return ele.EntityHierarchyKey == payload.entityHierarchyKey;
        });

        // try order object
        if(!findDetails){
          findDetails = state.order.Individual.find((ele) => {
            return ele.OrderEntityKey == payload.orderEntityKey;
          });
        }

        alert('individual '+findDetails.Name);
      }





      if (findDetails) {
        const findActivity = findDetails.Activities.find((ele) => {
          return ele.EntityHierarchyKey == payload.entityHierarchyKey;
        });

        alert('findActivity.Name '+findActivity.Name);

        if (findActivity && findActivity.SelectedTimes) {
          alert('--------findActivity.Name '+findActivity.Name);
          var findTime = findActivity.SelectedTimes.find((ele) => {
            return ele.Value == payload.timeId;
          });

          if (findTime) {
            findTime.AddOnsSkipped = true;

            // set Quantity to 0

            payload.callback({});
          }
        }
      }




      // var findActivity = state.activeProductDetails.Activities.find((ele) => {
      //   return ele.EntityHierarchyKey == payload.entityHierarchyKey;
      // });

      // if (findActivity) {
      //   var findTime = findActivity.Times.find((ele) => {
      //     return ele.Value == payload.timeId;
      //   });

      //   if (findTime) {
      //     alert('fimeTime');
      //   }

      // }

    },
*/
		/*
        mutateTimeSlotRequirements(state, payload) {
    
          //alert('mutateTimeSlotRequirements, timeSlotId: ' + payload.timeSlotId);
    
          //alert('state.activeProductIds.productType: ' + state.activeProductIds.productType);
    
          if (state.activeProductIds.productType == 'activity') {
    
            // find this timeSlot
            //state.activeProductDetails.
    
          }
    
          else {
    
          }
    
    
        },
        */

		resetGiftcard(state) {
			state.client.GiftCard.FromName = '';
			state.client.GiftCard.GiftCardAmount = null;
			state.client.GiftCard.GiftCardAmountOther = null;
			state.client.GiftCard.GiftCardAmountSelection = null;
			state.client.GiftCard.Message = '';
			state.client.GiftCard.RecipientEmail = '';
			state.client.GiftCard.RecipientName = '';
		},

		updateOverlappedActivities(state, payload) {
			state.overlappedActivities = payload;
		},

		preBookRead(state, payload) {
			//alert('preBookRead');
			var find = false;

			if (payload.PackageKey) {
				find = state.client.Packages.find((ele) => {
					return payload.PackageKey == ele.PackageKey;
				});
			} else {
				find = state.client.Individual.find((ele) => {
					return payload.EntityHierarchyKey == ele.EntityHierarchyKey;
				});
			}

			if (find) {
				find.hasReadPreBookMessage = true;
			}
		},

		updateProductToRemove: (state, payload) => {
			state.productToRemove = payload;
		},

		forceUpdateOrder(state) {
			Vue.localStorage.remove('orderKey');
			Vue.localStorage.remove('clientLocationKey');
			Vue.localStorage.remove('cardErrorReq');
			localStorage.removeItem('CData');
			state.order = {};
		},

		updateOrder: (state, payload) => {
			if (!payload) {
				console.error('Payload is null');
				return;
			}
			if (payload.OrderKey) {
				state.order = payload;
				Vue.localStorage.set('orderKey', payload.OrderKey);
				Vue.localStorage.set(
					'clientLocationKey',
					router.currentRoute.params.client
				);
			}
			//
			else {
				console.warn('Trying to call updateOrder() without an OrderKey.');
			}
		},
		updateCustomer: (state, payload) => {
			if (state.order) {
				state.order.Customer = payload;
			} else {
				console.warn('No order to update customer');
			}
		},
		updateClient: (state, payload) => {
			state.client = payload;
			state.clientOriginal = JSON.parse(JSON.stringify(payload));
		},

		updateActiveProductIds: (state, payload) => {
			//alert("updateActiveProductIds");
			//console.log("updateActiveProductIds", payload);
			console.log(payload);
			state.activeProductIds = payload;
		},
	},
	// ajax here
	actions: {
		// init Sojern
		//TODO: initSojernSearchPixelId
		// eslint-disable-next-line
		initSojernSearchPixelId({ state }, payload) {
			/* Please fill the following values. */

			//console.log("initSojernSearchPixelId().........");

			var params = {
				vid: 'tou' /* Don't Change */,
				et: 'vs' /* Don't Change */,
				vd1: '' /* Departure Date */,
				vd2: '' /* Return Date */,
				vf1: '' /* Destination City */,
				vs1: '' /* Destination State or Region */,
				vn1: '' /* Destination Country */,
				t: '' /* Number of Travelers */,
			};
			/* Please do not modify the below code. */

			var cid = [];
			var paramsArr = [];
			var cidParams = [];
			var pl = document.createElement('script');
			//var defaultParams = { vid: "tou", et: "vs" };
			/*for (key in defaultParams) {
        params[key] = defaultParams[key];
      }*/
			for (let key in cidParams) {
				cid.push(params[cidParams[key]]);
			}
			params.cid = cid.join('|');

			const keys = Object.keys(params);
			//
			for (const key of keys) {
				//console.log("key", key);
				//console.log("params[key]", params[key]);
				paramsArr.push(key + '=' + encodeURIComponent(params[key]));
			}

			// for (const [key, val] of params) {
			//   console.log("key", key);
			//   console.log("val", val);
			//   paramsArr.push(key + "=" + encodeURIComponent(params[key]));
			// }

			//console.table(paramsArr);

			//for (key in params) {
			//paramsArr.push(key + "=" + encodeURIComponent(params[key]));
			//}
			pl.type = 'text/javascript';
			pl.async = true;
			pl.src =
				'https://beacon.sojern.com/pixel/p/' +
				state.client.SojernSearchPixelId +
				'?f_v=v6_js&p_v=1&' +
				paramsArr.join('&');

			(
				document.getElementsByTagName('head')[0] ||
				document.getElementsByTagName('body')[0]
			).appendChild(pl);
		},

		// eslint-disable-next-line no-empty-pattern
		closeDetailComponent({}, payload) {
			router.push({
				path: '/' + router.currentRoute.params.client + '/' + payload,
			});
		},
		updateClientAgentKey: ({ state }, key) => {
			state.agentKey = key;
		},

		viewAllExp() {
			router.push({ path: '/' + router.currentRoute.params.client });
		},

		closeRemoveFromCartModal: ({ commit, state }) => {
			state.removeFromCartModal.show = false;
			commit('updateProductToRemove', {});
		},

		confirmRemoveFromCart: ({ commit, state }, payload) => {
			// console.log("...confirmRemoveFromCart", payload);
			state.removeFromCartModal.show = true;
			commit('updateProductToRemove', payload);
		},

		removeFromCart: ({ commit, state }) => {
			var data = {};
			data.orderKey = state.order.OrderKey;
			data.clientLocationKey = router.currentRoute.params.client;

			// Package
			if (state.productToRemove.isPackage) {
				data.OrderPackageKey = state.productToRemove.OrderPackageKey; //
				state.removeFromCartModal.loading = true;

				window.$.ajax({
					type: 'GET',
					url: state.serverPath + '/RemovePackageFromCart',
					dataType: 'json',
					data: data,
					cache: false,
					success: (order) => {
						commit('updateOrder', order);
						// close the modal
						state.removeFromCartModal.loading = false;
						state.removeFromCartModal.show = false;
						setTimeout(() => {
							if (order.CartCount == 0) {
								router.push({
									path: '/' + router.currentRoute.params.client + '?top=true',
								});
							}
						}, 200);
					}, // success
				}); // ajax
			}

			// GiftCard
			else if (state.productToRemove.IsGiftCard) {
				data.OrderMerchandiseKey = state.productToRemove.OrderMerchandiseKey; //
				state.removeFromCartModal.loading = true;

				window.$.ajax({
					type: 'GET',
					url: state.serverPath + '/RemoveGiftCardFromCart',
					dataType: 'json',
					data: data,
					cache: false,
					success: (order) => {
						//if (order.OrderKey) {
						commit('updateOrder', order);
						//}

						// close the modal
						state.removeFromCartModal.loading = false;
						state.removeFromCartModal.show = false;

						setTimeout(() => {
							if (order.CartCount == 0) {
								router.push({
									path: '/' + router.currentRoute.params.client + '?top=true',
								});
							}
						}, 200);
					}, // success
				}); // ajax
			}

			// Individual
			else {
				data.orderEntityKey = state.productToRemove.OrderEntityKey; // !TODO - need to rework API for you data structure...
				state.removeFromCartModal.loading = true;
				//RemoveActivityFromCart(Guid orderKey, Guid orderEntityKey, int clientLocationKey)
				window.$.ajax({
					type: 'GET',
					url: state.serverPath + '/RemoveActivityFromCart',
					dataType: 'json',
					data: data,
					cache: false,
					success: (order) => {
						commit('updateOrder', order);

						// close the modal
						state.removeFromCartModal.loading = false;
						state.removeFromCartModal.show = false;

						setTimeout(() => {
							if (order.CartCount == 0) {
								router.push({
									path: '/' + router.currentRoute.params.client + '?top=true',
								});
							}
						}, 200);

						// this.ajaxing = false;

						// this.$store.commit("hideLoader");

						// this.$router.push({ path: "/" + tis.$route.params.client });
					}, // success
					error: (err) => {
						state.removeFromCartModal.loading = false;
						console.warn(err);
					},
				});
			}
		},

		// eslint-disable-next-line no-empty-pattern
		goToAddons: ({}, payload) => {
			console.log('goToAddons');
			var r = router.currentRoute.params;
			var path =
				'/' +
				r.client +
				'/' +
				payload.productType +
				'/' +
				r.modify +
				'/' +
				r.id +
				'/' +
				r.clientAgentKey +
				'/addons/' +
				payload.entityHierarchyKey +
				'/' +
				payload.timeId;
			//var path = '/1';
			router.push({ path: path });
		},

		getDetails: ({ commit, state, dispatch }, payload) => {
			// is the cliet object empty?

			if (Object.keys(state.client).length === 0) {
				//alert("store getDetails() if");
				dispatch('ajaxClient', payload);
			}
			//
			else {
				//alert("store getDetails() else");
				commit('updateActiveProductIds', payload);
				if (typeof payload.callback == 'function') {
					payload.callback();
				}
			}
		},

		ajaxGetTimes: async ({ state }, payload) => {
			let callTs = window.performance.now().toFixed(0);
			console.log('getTimes() request', callTs, payload);
			// if (state.getTimesLoading) {
			//   console.warn("state.getTimesLoading", state.getTimesLoading);
			// }

			if (payload.EntityHierarchyKey && !state.getTimesLoading) {
				//alert('store.ajaxGetTimes if');

				// https://www.w3schools.com/jsref/jsref_toisostring.asp
				// Return a Date object as a String, using the ISO standard:
				//console.log(payload.Date);
				let parts = payload.Date.split('-');
				// Please pay attention to the month (parts[1]); JavaScript counts months from 0:
				// January - 0, February - 1, etc.
				let mydate = new Date(parts[0], parts[1] - 1, parts[2]);
				payload.Date = mydate.toISOString();

				//console.error("TODO: make sure gettimes is passing Order object.")

				if (payload.OrderEntityKey || payload.OrderPackageKey) {
					payload.Order = state.order;
				}

				// add current activity to getTimes call
				// const apd = getters.activeProductDetails;
				// payload.Activity = apd ? apd : null;

				console.log("getTimes payload");
				console.log(JSON.stringify(payload));

				state.getTimesLoading = true;
				window.$.ajax({
					type: 'POST',
					url: state.serverPath + '/gettimes',
					dataType: 'json',
					contentType: 'application/json',
					data: await gzip(JSON.stringify(payload)).then((z) => {
						return z;
					}),
					processData: false,
					headers: {
						'Content-Encoding': 'gzip',
					},
					cache: false,
					success: (json) => {
						console.log('getTimes() response', callTs, json);
						setTimeout(() => {
							state.getTimesLoading = false;
						}, 1000);

						// console.log('store json ', json);
						// alert('store.ajaxGetTimes');
						payload.callback(json);
					},
					error: function(e) {
						setTimeout(() => {
							state.getTimesLoading = false;
							console.error(e);
						}, 1000);
					},
				});
			} else {
				console.warn('aborting getTimes() request', callTs);
				state.getTimesLoading = false;
				payload.abort();
			}
		}, // ajaxGetTimes

		saveCustomer: async ({ state }, payload) => {
			window.$.ajax({
				type: 'POST',
				url: state.serverPath + '/savecustomer',
				dataType: 'json',
				contentType: 'application/json',
				data: await gzip(JSON.stringify(payload)).then((z) => {
					return z;
				}),
				processData: false,
				headers: {
					'Content-Encoding': 'gzip',
				},
				cache: false,
				success: (json) => {
					if (typeof payload.callback == 'function') {
						payload.callback(json);
					}
				},
			});
		}, // saveCustomer

		isValidEmail: ({ state }, payload) => {
			if (payload.email === '' || !payload.email) {
				payload.callback(true);
			} else {
				// do simple client side email validation
				if (/(.+)@(.+){2,}\.(.+){2,}/.test(payload.email)) {
					// valid email
					window.$.ajax({
						type: 'GET',
						url: state.serverPath + '/isvalidemail',
						dataType: 'json',
						data: payload,
						cache: false,
						success: (json) => {
							payload.callback(json);
						},
					});
				} else {
					// invalid email
					payload.callback(false);
				}
			}
		}, // saveCustomer

		/*
        myAction(context, data) {
          return new Promise((resolve, reject) => {
            // Do something here... lets say, a http call using vue-resource
            this.$http("/api/something").then(response => {
              // http success, call the mutator and change something in state
              resolve(response);  // Let the calling function know that http is done. You may send some data back
            }, error => {
              // http failed, let the calling function know that action did not work out
              reject(error);
            })
          })
        },
    */

		ajaxAddToCart: async ({ commit, state }, payload) => {
			let callTs = window.performance.now().toFixed(0);
			console.log('addToCart() request', callTs, payload);
			return new Promise(async (resolve, reject) => {
				window.$.ajax({
					type: 'POST',
					url: state.serverPath + '/addtocart',
					dataType: 'json',
					contentType: 'application/json',
					data: await gzip(JSON.stringify(payload)).then((z) => {
						return z;
					}),
					processData: false,
					headers: {
						'Content-Encoding': 'gzip',
					},
					cache: false,
					success: (json) => {
						console.log('addToCart() response', callTs, json);
						//if (json.Order && json.Order.OrderKey) {
						//Vue.localStorage.set("orderKey", json.Order.OrderKey);
						commit('updateOrder', json.Order);
						//}

						resolve(json);
					},
					error(err) {
						console.log(`addToCart() request ${callTs} failed`);
						reject(err);
					},
				});
			});
		},

		completeOrder: async ({ state }, payload) => {
			return new Promise(async (resolve, reject) => {
				window.$.ajax({
					type: 'POST',
					url: state.serverPath + '/completeorder',
					dataType: 'json',
					contentType: 'application/json',
					data: await gzip(JSON.stringify(payload)).then((z) => {
						return z;
					}),
					processData: false,
					headers: {
						'Content-Encoding': 'gzip',
					},
					cache: false,
					success: (json) => {
						resolve(json);
					},
					error(err) {
						reject(err);
					},
				});
			}); // Promise
		}, // completeOrder()
		saveOrderProgress: async ({ state }, isCustomerField) => {
			let callTS = window.performance.now().toFixed(0);
			var stateOrder = state.order;
			stateOrder.IsCustomerField = isCustomerField;
			if (state.updateOrderManagement.timer) {
				clearTimeout(state.updateOrderManagement.timer);
				state.updateOrderManagement.timer = null;
			}
			state.updateOrderManagement.timer = setTimeout(async function() {
				if (state.updateOrderManagement.ajax) {
					state.updateOrderManagement.ajax.abort();
				}
				console.log('saveOrderProgress() request', callTS, stateOrder);
				state.updateOrderManagement.ajax = window.$.ajax({
					type: 'POST',
					dataType: 'json',
					url: state.serverPath + '/updateorder',
					contentType: 'application/json',
					data: await gzip(JSON.stringify(stateOrder)).then((z) => {
						return z;
					}),
					processData: false,
					headers: {
						'Content-Encoding': 'gzip',
					},
					cache: false,
					success: (json) => {
						console.log('saveOrderProgress() response', callTS, json);

						if (json.ExceptionMessage) {
							console.error(json.ExceptionMessage);
						} else if (json.ModelErrors) {
							console.error(json.ModelErrors);
							window.alert('There was an issue performing this action');
						} else if (json.Order) {
							console.log('saveOrderProgress successful');
							// commit("updateOrder",json.Order)
						}
					},
					error: (json) => {
						console.log(`saveOrderProgress() request ${callTS} error`, json);
					},
					abort: () => {
						console.log(`saveOrderProgress() request ${callTS} aborted`);
					},
				});
			}, 50);
		},
		ajaxGetMonthAvailability: async ({ state }, payload) => {
			if (payload.Rates.length) {
				if (state.currentAjaxCall) {
					// properly cancel current ajax call
					console.warn('Cancelling GMA ajax call');
					state.currentAjaxCall.abort();
					state.currentAjaxCall = null;
				}

				state.currentAjaxCall = window.$.ajax({
					type: 'POST',
					dataType: 'json',
					url: state.serverPath + '/getmonthavailability',
					contentType: 'application/json',
					data: JSON.stringify(payload),
					cache: false,
					success: (json) => {
						window.lastGMA = false;
						payload.callback(json);
					},
				});
			}
		},

		ajaxClient: ({ commit, state, dispatch }, payload) => {
			if (
				Vue.localStorage.get('clientLocationKey', false) !=
				router.currentRoute.params.client
			) {
				Vue.localStorage.remove('orderKey');
			}

			if (router.currentRoute.params.orderKey) {
				//Vue.localStorage.set("orderKey", router.currentRoute.params.orderKey);
				Vue.localStorage.set(
					'clientLocationKey',
					router.currentRoute.params.client
				);
			}

			// use production location cache
			if (process.env.NODE_ENV == 'production') {
				let json = window.clientLocation;

				if (json) {
					// for google analytics
					window.GADomain = json.Domain;
					window.GATrackingId = json.GATrackingId;

					//
					dispatch('initSojernSearchPixelId', {});

					commit('updateClient', json);
					if (payload.id) {
						commit('updateActiveProductIds', payload);
					}

					// call /getorder
					if (payload.getOrderNext !== false) {
						dispatch('ajaxOrder');
					}
				}
			}

			// if (

			// 	payload.force ||
			// 	(Object.keys(state.client).length === 0 &&
			// 		payload.client &&
			// 		!state.client.ajaxing)
			// )

			// dev environment
			else {
				//alert('ajaxClient ');
				state.client.ajaxing = true;

				var url =
					state.serverPath +
					'/getclientlocation?clientLocationKey=' +
					payload.client;

				window.$.ajax({
					type: 'GET',
					url: url,
					//data: form,
					//traditional: true,
					cache: false,
					success: (json) => {
						console.debug('fetching getClientLocation');
						state.client.ajaxing = false;

						// for google analytics
						window.GADomain = json.Domain;
						window.GATrackingId = json.GATrackingId;

						//
						dispatch('initSojernSearchPixelId', {});

						commit('updateClient', json);
						if (payload.id) {
							commit('updateActiveProductIds', payload);
						}

						// call /getorder
						if (payload.getOrderNext !== false) {
							dispatch('ajaxOrder');
						}
					},
					error: (err) => {
						//alert("getclientlocation failed");
						console.warn(err);
					},
				});
			}
		},

		ajaxOrder: ({ commit, state, dispatch }, orderKey) => {
			//alert('ajaxOrder');
			orderKey = orderKey || Vue.localStorage.get('orderKey');
			// console.log("Loading order",orderKey)
			state.getOrderLoading = false;
			if (
				Vue.localStorage.get('clientLocationKey', false) !=
				router.currentRoute.params.client
			) {
				Vue.localStorage.remove('orderKey');
			} else {
				Vue.localStorage.set(
					'clientLocationKey',
					router.currentRoute.params.client
				);
			}
			return new Promise((resolve, reject) => {
				// var orderKey = Vue.localStorage.get("orderKey", false);

				//alert("ajaxOrder orderKey " + orderKey);

				var url = state.serverPath + '/getorder';

				if (!orderKey) {
					//Vue.localStorage.set("orderKey", false);
					console.warn('Unable to process order, OrderKey is null');
					//           reject({ error: "OrderKey is undefined." });
				}
				//
				else {
					state.getOrderLoading = true;
					var payload = {
						orderKey: orderKey,
						clientLocationKey: router.currentRoute.params.client,
					};
					window.$.ajax({
						type: 'GET',
						url: url,
						dataType: 'json',
						data: payload,
						cache: false,
						success: (json) => {
							state.getOrderLoading = false;

							console.log('ajaxOrder', json.OrderKey);

							if (json.InValidOrderKey) {
								console.warn('InValidOrderKey for ajaxOrder ... /getorder');
								resolve(null);
								// Vue.localStorage.remove("orderKey");
								// reject({
								//   error: "InValidOrderKey for ajaxOrder ... /getorder"
								// });
							}

							// json is the Order object
							else if (json.OrderKey) {
								dispatch('updateClientAgentKey', json.ClientAgentKey);
								commit('updateOrder', json);
								//Vue.localStorage.set("orderKey", json.OrderKey);
								resolve(json);
							} else {
								//commit("updateOrder", { OrderKey: json.orderKey });
								// Vue.localStorage.set('orderKey', json.orderKey);
								reject({ error: 'OrderKey is missing from json' });
							}
						},
						error: (err) => {
							state.getOrderLoading = false;
							console.warn('getOrder failed');
							console.warn(err);
							Vue.localStorage.remove('orderKey');
							Vue.localStorage.remove('clientLocationKey');
							reject(err);
						},
					});
				} // if orderKey
			}); // Promise
		},

		startOver({ commit, state }, payload) {
			//console.log('startOver()');
			var url =
				state.serverPath +
				'/AbandonOrderChanges?orderKey=' +
				state.order.OrderKey;
			commit('forceUpdateOrder', {});
			Vue.localStorage.remove('orderKey');
			Vue.localStorage.remove('clientLocationKey');
			Vue.localStorage.remove('cardErrorReq');
			localStorage.removeItem('CData');

			window.$.ajax({
				type: 'GET',
				url: url,
				data: { clientLocationKey: router.currentRoute.params.client },
				cache: false,
				success: () => {
					//this will always return "null"
					// commit("removeStorage", { name: "orderKey" });

					state.discount = {
						value: '',
						message: '',
						error: '',
						ajaxing: false,
					};

					payload.success(); // callback
				},
				error: (message) => {
					console.warn(message);
					payload.error(); // callback
					//alert('AbandonOrderChanges');
					router.push({ path: '/' + router.currentRoute.params.client });
				},
			}); // ajax
		}, //startOver
	},
});
